<template>
    <b-container fluid class="mt--7">
        <create-role-form
            v-if="createdMode"
            @cancel="createdMode = false"
            @success="showSuccess"
            @error="showError"
        ></create-role-form>

        <role-table v-else ref="table" @add-role="createdMode = true">
        </role-table>
    </b-container>
</template>
<script>
import RoleTable from './RoleTable'
import CreateRoleForm from './CreateRoleForm'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'roles',
    mixins: [popupMixins, permissionsMixins],
    components: {
        RoleTable,
        CreateRoleForm,
    },
    data: () => {
        return {
            componentName: 'Role',
            createdMode: false,
            importModal: false,
        }
    },
    mounted() {
        this.$refs.table.doSearch()
    },

    methods: {
        hideModal() {
            this.createdMode = false
            this.importModal = false
            this.$refs.table.doSearch()
        },
        showAddModal() {
            this.$refs.modal.showModal()
        },
        showImportModal() {
            this.importModal = true
        },
        showError(error, name) {
            if (error === 'Duplicate Name!') {
                this.genericToast(
                    this.componentName,
                    'Duplicate',
                    'danger',
                    `"${name}" already exists as an ${
                        this.componentName
                    }. Please create a new ${this.componentName.toLowerCase()}`
                )
            } else if (error.name) {
                this.genericToast(
                    'Role Creation',
                    'Error',
                    'danger',
                    'The "name" field is required to create a role'
                )
            }
        },

        showSuccess(action) {
            console.log('Attempt Emit')
            this.genericToast(
                this.componentName,
                action,
                'success',
                `Role has been successfully ${action.toLowerCase()}`
            )

            if (action.toLowerCase() === 'created') {
                this.createdMode = false
            }
        },
        // roleCreated() {
        //     this.genericToast(
        //         this.componentName,
        //         'Created',
        //         'success',
        //         'Role has been created successfully'
        //     )
        //     // this.doToast('Created!', 'Role Created', 'success')
        //     this.createdMode = false
        // },
    },
}
</script>
<style></style>
